import { createQueryClient } from '@mint-lib/query-client';

import { MintServiceLocatorAbstractFactoryContext } from '../types.js';

export async function queryClientFactory(
  ctx: MintServiceLocatorAbstractFactoryContext,
) {
  const queryClient = createQueryClient();
  ctx.on('auth', 'logout', () => queryClient.clear());

  return queryClient;
}
